import type { I18N_CONF } from '@funkey/locales/config';

export const FLAG_ICONS = {
    BE: function BEIcon(props: React.SVGProps<SVGSVGElement>) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <path fillRule="evenodd" clipRule="evenodd" d="M6 0H17V24H6V0Z" fill="#FECA00" />
                <path fillRule="evenodd" clipRule="evenodd" d="M17 0H28V24H17V0Z" fill="#E31D1C" />
                <path fillRule="evenodd" clipRule="evenodd" d="M-4 0H7V24H-4V0Z" fill="#1D1D1D" />
            </svg>
        );
    },

    NL: function NLIcon(props: React.SVGProps<SVGSVGElement>) {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 5 3" {...props}>
                <path fill="#E31D1C" d="M0,0H5V1H0Z" />
                <path fill="#F7FCFF" d="M0,1H5V2H0Z" />
                <path fill="#3D58DB" d="M0,2H5V3H0Z" />
            </svg>
        );
    },

    FR: function FRIcon(props: React.SVGProps<SVGSVGElement>) {
        return (
            <svg
                width="18"
                height="14"
                viewBox="0 0 18 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <g clipPath="url(#clip0_9340_6741)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 1H17V13H12V1Z"
                        fill="#F50100"
                    />
                    <path fillRule="evenodd" clipRule="evenodd" d="M1 1H7V13H1V1Z" fill="#2E42A5" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 1H12V13H6V1Z"
                        fill="#F7FCFF"
                    />
                </g>
                <rect x="0.5" y="0.5" width="17" height="13" rx="2.5" stroke="white" />
                <defs>
                    <clipPath id="clip0_9340_6741">
                        <rect x="1" y="1" width="16" height="12" rx="2" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    },

    GB: function GBIcon(props: React.SVGProps<SVGSVGElement>) {
        return (
            <svg
                width="18"
                height="14"
                viewBox="0 0 18 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...props}
            >
                <g clipPath="url(#clip0_9340_2259)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1 1V13H17V1H1Z"
                        fill="#2E42A5"
                    />
                    <mask
                        id="mask0_9340_2259"
                        style={{
                            maskType: 'luminance',
                        }}
                        maskUnits="userSpaceOnUse"
                        x="1"
                        y="1"
                        width="16"
                        height="12"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M1 1V13H17V1H1Z"
                            fill="white"
                        />
                    </mask>
                    <g mask="url(#mask0_9340_2259)">
                        <mask
                            id="mask1_9340_2259"
                            style={{
                                maskType: 'luminance',
                            }}
                            maskUnits="userSpaceOnUse"
                            x="1"
                            y="1"
                            width="16"
                            height="12"
                        >
                            <rect x="1" y="1" width="16" height="12" fill="white" />
                        </mask>
                        <g mask="url(#mask1_9340_2259)">
                            <path
                                d="M-0.781616 12.1427L2.73923 13.6317L17.0798 2.6189L18.937 0.406163L15.172 -0.0915146L9.32278 4.65422L4.61478 7.85174L-0.781616 12.1427Z"
                                fill="white"
                            />
                            <path
                                d="M-0.299622 13.1859L1.49409 14.05L18.2701 0.200579H15.7515L-0.299622 13.1859Z"
                                fill="#F50100"
                            />
                            <path
                                d="M18.7816 12.1427L15.2607 13.6317L0.920092 2.6189L-0.937073 0.406163L2.82796 -0.0915146L8.67716 4.65422L13.3852 7.85174L18.7816 12.1427Z"
                                fill="white"
                            />
                            <path
                                d="M18.6614 12.8914L16.8677 13.7555L9.72433 7.82582L7.60646 7.16331L-1.11576 0.413708H1.40282L10.1201 7.0031L12.4356 7.79752L18.6614 12.8914Z"
                                fill="#F50100"
                            />
                            <mask id="path-10-inside-1_9340_2259" fill="white">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.8889 0H7.11108V5H0.0137329V9H7.11108V14H10.8889V9H18.0137V5H10.8889V0Z"
                                />
                            </mask>
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M10.8889 0H7.11108V5H0.0137329V9H7.11108V14H10.8889V9H18.0137V5H10.8889V0Z"
                                fill="#F50100"
                            />
                            <path
                                d="M7.11108 0V-1H6.11108V0H7.11108ZM10.8889 0H11.8889V-1H10.8889V0ZM7.11108 5V6H8.11108V5H7.11108ZM0.0137329 5V4H-0.986267V5H0.0137329ZM0.0137329 9H-0.986267V10H0.0137329V9ZM7.11108 9H8.11108V8H7.11108V9ZM7.11108 14H6.11108V15H7.11108V14ZM10.8889 14V15H11.8889V14H10.8889ZM10.8889 9V8H9.88885V9H10.8889ZM18.0137 9V10H19.0137V9H18.0137ZM18.0137 5H19.0137V4H18.0137V5ZM10.8889 5H9.88885V6H10.8889V5ZM7.11108 1H10.8889V-1H7.11108V1ZM8.11108 5V0H6.11108V5H8.11108ZM0.0137329 6H7.11108V4H0.0137329V6ZM1.01373 9V5H-0.986267V9H1.01373ZM7.11108 8H0.0137329V10H7.11108V8ZM8.11108 14V9H6.11108V14H8.11108ZM10.8889 13H7.11108V15H10.8889V13ZM9.88885 9V14H11.8889V9H9.88885ZM18.0137 8H10.8889V10H18.0137V8ZM17.0137 5V9H19.0137V5H17.0137ZM10.8889 6H18.0137V4H10.8889V6ZM9.88885 0V5H11.8889V0H9.88885Z"
                                fill="white"
                                mask="url(#path-10-inside-1_9340_2259)"
                            />
                        </g>
                    </g>
                </g>
                <rect x="0.5" y="0.5" width="17" height="13" rx="2.5" stroke="white" />
                <defs>
                    <clipPath id="clip0_9340_2259">
                        <rect x="1" y="1" width="16" height="12" rx="2" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    },

    LU: () => (
        <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 5 3">
            <path fill="#ef3340" d="M0,0H5V1H0Z" />
            <path fill="#fff" d="M0,1H5V2H0Z" />
            <path fill="#00a3e0" d="M0,2H5V3H0Z" />
        </svg>
    ),
} satisfies Record<string, React.FC>;

export const TRANSLATION_MAP: Record<
    I18N_CONF.Language,
    {
        icon: React.FC<React.SVGProps<SVGSVGElement>>;
        label: React.ReactNode;
    }
> = {
    nl: {
        label: 'Nederlands',
        icon: FLAG_ICONS.NL,
    },
    fr: {
        label: 'français',
        icon: FLAG_ICONS.FR,
    },
    en: {
        label: 'English',
        icon: FLAG_ICONS.GB,
    },
};
